const getters = {
    couponCart: state => state.couponCart,
    couponApplied: state => state.couponApplied,
    couponStatus: state => state.couponStatus,
    couponErrors: state => state.couponErrors,
    couponMessage: state => state.couponMessage,
    discountTotal: state => state.discountTotal,
};

export default getters;
